import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/dashboard/organizations')({
    component: RouteComponent,
    staticData: {
        theme: 'electrical',
    },
});

function RouteComponent() {
    return <Outlet />;
}
